import Cookies from 'js-cookie';

class SecureCookieStorage {
  public setItem(key: string, value: any) {
    Cookies.set(key, value);
  }

  public getItem(key: string) {
    return Cookies.get(key);
  }

  public removeItem(key: string) {
    Cookies.remove(key);
  }
}

export const cookieStorageService = new SecureCookieStorage();
